export interface FareTypeInterface {
    fare: string
    code: string
    active: boolean
    toolTipMsg?: string
    toolTipErrorMsg?: string
    subtitle?: string
}

export const PTC_FARE_CATEGORY = {
  student: 'RETAIL_STUDENT',
  senior_citizen: 'RETAIL_SENIOR_CITIZEN',
  army: 'RETAIL_ARMY',
} as const

export type PtcFareTypeCode = keyof typeof PTC_FARE_CATEGORY

export const PTC_FARE_STRIP_LABEL: Record<PtcFareTypeCode, string> = {
  student: 'Show student fare only',
  senior_citizen: 'Show senior citizen fare only',
  army: 'Show armed forces fare only',
}

const PTC_STRIP_PRIORITY: PtcFareTypeCode[] = ['student', 'senior_citizen', 'army']

export function resolveRevampPtcStripType(
  sftFareType?: string,
  ptcAvailability?: Partial<Record<PtcFareTypeCode, boolean>>
): PtcFareTypeCode | null {
  if (sftFareType === 'student' || sftFareType === 'senior_citizen' || sftFareType === 'army') {
    return sftFareType
  }
  return PTC_STRIP_PRIORITY.find(type => ptcAvailability?.[type]) || null
}

export const SENIOR_CITIZEN_FARE_TYPE = 'SENIOR CITIZEN'

export const FARE_TYPE: FareTypeInterface[] = [
    // { fare: 'Regular fare', code: 'rf', active: true },
    {
        fare: 'Student',
        code: 'student',
        active: true,
        toolTipMsg:
            'Only students above the age of 12 with valid ID can avail this special fare and any additional baggage allowance',
        toolTipErrorMsg: 'You cannot select Student fare with infants/child added to the journey',
        subtitle: 'Extra baggage, discounts'
    },
    {
        fare: 'Senior citizen',
        code: 'senior_citizen',
        active: true,
        toolTipMsg: 'Only senior citizens above the age of 60 years can avail this special fare.',
        toolTipErrorMsg: 'You cannot select Senior citizen fare with infants/child added to the journey',
        subtitle: 'Up to ₹600 off'
    },
    {
        fare: 'Armed forces',
        code: 'army',
        active: true,
        toolTipMsg: 'Only serving/retired Indian armed forces personnel & their dependents can avail this fare.',
        subtitle: 'Up to ₹600 off'
    }
]
export const returnFareName = (code: string) => FARE_TYPE.find(fare => fare.code === code)?.fare || ''

export function returnFareNameItin(fareType: string) {
    switch (fareType) {
        case 'STUDENT FARE':
            return 'Student fare'
        case 'ARMED FORCES FARE':
            return 'Armed forces fare'
        case 'SENIOR CITIZEN FARE':
            return 'Senior citizen fare'
        default:
            return 'Regular fare'
    }
}

export const STUDENT_BENEFITS_MODAL_DATA = {
  title: 'Student fares',
  subtitle: 'For students aged 12+ yrs',
  benefits: [
    {
      icon: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,c_fill,e_sharpen:90/staticresource-prod/images/studentFareImages/suitcase.png',
      label: 'Free extra baggage',
    },
    {
      icon: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,c_fill,e_sharpen:90/staticresource-prod/images/studentFareImages/lock.png',
      label: 'Discounts up to 10%',
    },
    {
      icon: 'https://rukmini-ct.flixcart.com/f_auto,q_auto,c_fill,e_sharpen:90/staticresource-prod/images/studentFareImages/calender.png',
      label: 'Cheaper cancel, date change',
    },
  ],
  footerTitle: 'Eligibility',
  footerSubtitle: 'Carry a valid physical Student ID card and Student Visa (if applicable) at the airport',
  btnText: 'Sounds great!',
}

export const REVAMP_FARE_CHIP_CLASS =
  'flex flex-middle flex-cg-2 h-9 py-1 px-2 ba-solid bc-line-500 br-4 bg-white c-pointer flex-no-shrink ws-nowrap'
